import styled from 'styled-components';

export const PageBody = styled.div`
  main {
    min-height: 100vh;
  };
`;